import {createAction, props} from '@ngrx/store';

export const pageChanged = createAction(
  '[PagingStore] pageChanged',
  props<{
    key: string;
    newPageIndex: number;
  }>()
);
